import { useEffect } from 'react';
import { getBackgroundStyle } from '../data/backgroundLibrary';

const ThemeBackgrounds = ({ backgroundSections }) => {
  useEffect(() => {
    if (!backgroundSections) return;

    // Apply backgrounds to different sections
    const applyBackgrounds = () => {
      // Global background
      if (backgroundSections.global) {
        const style = getBackgroundStyle(backgroundSections.global);
        Object.entries(style).forEach(([key, value]) => {
          document.body.style[key] = value;
        });
      }

      // Hero section
      if (backgroundSections.hero) {
        const heroElements = document.querySelectorAll('.hero-section, [data-section="hero"]');
        const style = getBackgroundStyle(backgroundSections.hero);
        heroElements.forEach(el => {
          Object.entries(style).forEach(([key, value]) => {
            el.style[key] = value;
          });
        });
      }

      // Products section
      if (backgroundSections.products) {
        const productElements = document.querySelectorAll('.products-section, [data-section="products"]');
        const style = getBackgroundStyle(backgroundSections.products);
        productElements.forEach(el => {
          Object.entries(style).forEach(([key, value]) => {
            el.style[key] = value;
          });
        });
      }

      // Newsletter section
      if (backgroundSections.newsletter) {
        const newsletterElements = document.querySelectorAll('.newsletter-section, [data-section="newsletter"]');
        const style = getBackgroundStyle(backgroundSections.newsletter);
        newsletterElements.forEach(el => {
          Object.entries(style).forEach(([key, value]) => {
            el.style[key] = value;
          });
        });
      }

      // Footer
      if (backgroundSections.footer) {
        const footerElements = document.querySelectorAll('footer, [data-section="footer"]');
        const style = getBackgroundStyle(backgroundSections.footer);
        footerElements.forEach(el => {
          Object.entries(style).forEach(([key, value]) => {
            el.style[key] = value;
          });
        });
      }
    };

    // Apply immediately
    applyBackgrounds();

    // Re-apply when DOM changes (for dynamic content)
    const observer = new MutationObserver(applyBackgrounds);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [backgroundSections]);

  return null;
};

export default ThemeBackgrounds;
